import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    collections: [],
    paginator: {},
    profiles: {},
    cached: false,
    fetchStatus: undefined
};

const getters = {};

const actions = {
    getAuthors({commit, state}) {
        return new Promise((resolve, reject) => {
            if (state.fetchStatus === 'fetchedAll') return resolve(state.collections);
            
            axios.get(api.getAuthors())
              .then(({data}) => {
                  commit(types.UPDATE_COLLECTIONS, data);
                  commit(types.SET_FETCH_STATUS, 'fetchedAll')
                  resolve(data);
              })
              .catch(({response}) => reject(response));
        });
    },
    
    getAuthorProfile({commit, state}, authorId) {
        if (state.profiles[authorId]) return state.profiles[authorId];
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);
            
            axios.get(api.findAuthor(authorId))
              .then(({data}) => {
                  commit(types.UPDATE_PROFILES, data);
                  resolve(data);
              })
              .catch(({response}) => reject(response))
              .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

const mutations = {
    [types.UPDATE_COLLECTIONS](state, collections) {
        state.collections = collections;
    },
    
    [types.UPDATE_PAGINATOR](state, paginator) {
        state.paginator = paginator;
    },
    
    [types.SET_CACHED_STATE](state, cached) {
        state.cached = cached;
    },
    
    [types.UPDATE_PROFILES](state, profile) {
        state.profiles[profile.id] = profile;
    },
    
    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },
    
    [types.SET_FETCH_STATUS](state, status) {
        state.fetchStatus = status;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};
